import { render, staticRenderFns } from "./AdminCurrentMeldungen.vue?vue&type=template&id=23d8ef51&scoped=true&"
import script from "./AdminCurrentMeldungen.vue?vue&type=script&lang=js&"
export * from "./AdminCurrentMeldungen.vue?vue&type=script&lang=js&"
import style0 from "./AdminCurrentMeldungen.vue?vue&type=style&index=0&id=23d8ef51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d8ef51",
  null
  
)

export default component.exports